__turbopack_context__.v({
  "accordionRoot": "TechnicalSpecs-module__ZXS5cG__accordionRoot",
  "desktopTable": "TechnicalSpecs-module__ZXS5cG__desktopTable",
  "mobileAccordion": "TechnicalSpecs-module__ZXS5cG__mobileAccordion",
  "technicalSpec": "TechnicalSpecs-module__ZXS5cG__technicalSpec",
  "technicalSpecsRoot": "TechnicalSpecs-module__ZXS5cG__technicalSpecsRoot",
  "twoImageRoot": "TechnicalSpecs-module__ZXS5cG__twoImageRoot",
});
